enum Language {
    FRENCH = "fr-FR",
    ENGLISH = "en-US",
}

export default Language;
